import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../utils/axios/requestInfo";

import { api } from "../../resources/api";
import { IClubDocument } from "./types";

export const fetchPolicy = createAsyncThunk<IClubDocument | null>(
  "club/fetchPolicy",
  async () => {
    try {
      const response = await axiosInstance.get(api.club.POLICY);
      if (Array.isArray(response.data) && response.data.length > 0) {
        return response.data[0];
      }
      return response.data || null;
    } catch (error: any) {
      return null;
    }
  }
);

export const fetchRule = createAsyncThunk<IClubDocument | null>(
  "club/fetchRule",
  async () => {
    try {
      const response = await axiosInstance.get(api.club.RULE);
      if (Array.isArray(response.data) && response.data.length > 0) {
        return response.data[0];
      }
      return response.data[0] || null;
    } catch (error: any) {
      return null;
    }
  }
);

